import { z } from 'zod';

export const updateEnglishIqDemoV1RequestSchema = z
  .object({
    challengeId: z.number().int().positive(),
    clipIds: z.tuple([z.number().int().positive(), z.number().int().positive()]),
    enabled: z.boolean(),
    maximumScore: z.number().int().min(60).max(150).nullable(),
    minimumScore: z.number().int().min(60).max(150).nullable(),
  })
  .superRefine((value, context) => {
    const bothGlobal = value.minimumScore === null && value.maximumScore === null;
    const bothRanged = value.minimumScore !== null && value.maximumScore !== null;
    if (!bothGlobal && !bothRanged) {
      context.addIssue({ code: 'custom', message: 'Both score bounds are required' });
    }
    if (
      bothRanged &&
      value.minimumScore !== null &&
      value.maximumScore !== null &&
      value.minimumScore > value.maximumScore
    ) {
      context.addIssue({ code: 'custom', message: 'Minimum score must not exceed maximum score' });
    }
    if (value.clipIds[0] === value.clipIds[1]) {
      context.addIssue({ code: 'custom', message: 'Demo clips must be different' });
    }
  });

export type IUpdateEnglishIqDemoV1Request = z.infer<typeof updateEnglishIqDemoV1RequestSchema>;
